import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Modal from "../../Modal";
import InServiceForm from "../InServiceForm";
import { buildData } from "../utils";

const initState = {
  loading: false,
  saveDisabled: true,
  topic: "",
  startTime: moment('12:00 pm', 'hh:mm a').toDate(),
  endTime: moment('01:00 pm', 'hh:mm a').toDate(),
  selectedCategories: [],
  location: "",
  instructors: [],
  notes: "",
  generalFiles: [],
  instructorsFiles: [],
  classLimit: "",
  allowSignUps: false,
  status: "current",
  formKey: "new",
  errors: {}
};

class Add extends React.Component {
  state = { ...initState };

  handlerChangeInstructors = instructors => this.setState({ instructors, errors: {} });

  handlerChangeCategories = selectedCategories => this.setState({ selectedCategories, errors: {} });

  handleChangeAllowSignUps = e => this.setState({ allowSignUps: e.target.checked, errors: {} });

  handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    this.setState({ [name]: value, errors: {} });
  };

  handleAddAttachments = (files, category) =>
    this.setState({[category]: [ ...this.state[category], ...files ]});

  handleDeleteAttachment = (id, index, category) => {
    const files = this.state[category];
    files.splice(index, 1);
    this.setState({ [category]: files });
  };

  handleSaveDisabled = (saveDisabled) => {
    this.setState({ saveDisabled })
  }

  submit = () => {
    const { onAdded } = this.props;
    const data = buildData({ ...this.state });

    this.setState({ loading: true });
    axios.post("/in_services", data)
      .then(({ data }) => {
        toastr.success("Created.");
        this.resetState();
        onAdded(data);
      })
      .catch(({ response }) => {
        this.setState({
          loading: false,
          errors: response && response.data && response.data.errors ? response.data.errors : {}
        });
      })
    ;
  };

  resetState = () =>
    this.setState({ ...initState, formKey: new Date().getTime().toString() });

  render() {
    const { visible, categories, locations, defInstructors, onClose } = this.props;
    const {
      loading,
      saveDisabled,
      topic,
      location,
      selectedCategories,
      instructors,
      notes,
      generalFiles,
      instructorsFiles,
      allowSignUps,
      status,
      classLimit,
      errors,
      formKey
    } = this.state;

    return (
      <Modal
        title="Add In-Service"
        visible={visible}
        onClose={onClose}
      >
        <InServiceForm
          key={formKey}
          errors={errors}
          topic={topic}
          location={location}
          locations={locations}
          selectedCategories={selectedCategories}
          categories={categories}
          instructors={instructors}
          defInstructors={defInstructors}
          allowSignUps={allowSignUps}
          classLimit={classLimit}
          notes={notes}
          generalFiles={generalFiles}
          instructorsFiles={instructorsFiles}
          status={status}
          onChange={this.handleChange}
          onChangeCategories={this.handlerChangeCategories}
          onChangeInstructors={this.handlerChangeInstructors}
          onChangeAllowSignUps={this.handleChangeAllowSignUps}
          onAddAttachments={this.handleAddAttachments}
          onDeleteAttachment={this.handleDeleteAttachment}
          toggleSaveDisabled={this.handleSaveDisabled}
        />
        <br/>
        <button
          className="btn btn-pink btn-block btn-raised"
          disabled={loading || saveDisabled}
          onClick={this.submit}
        >
          SAV{loading ? "ING..." : "E"}
        </button>
      </Modal>
    );
  }
}

Add.propTypes = {
  categories: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  defInstructors: PropTypes.array.isRequired,
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onAdded: PropTypes.func.isRequired
};

Add.defaultProps = {
  visible: false
};

export default Add;
